import { render, staticRenderFns } from "./BankAccountListProvider.vue?vue&type=template&id=640d24a9&scoped=true&"
import script from "./BankAccountListProvider.vue?vue&type=script&lang=ts&"
export * from "./BankAccountListProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d24a9",
  null
  
)

export default component.exports